import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { CompanyPortfolioAssignmentDTO, SelectedCompanyAssignmentToMarkUnmarkFavorite } from '../../interface/portfolio.interface';
import { FilterPagination } from '../../../files-clients/interface/company-client.interface';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-company-assignments-portfolio-user',
  templateUrl: './company-assignments-portfolio-user.component.html',
  styleUrls: ['./company-assignments-portfolio-user.component.scss']
})
export class CompanyAssignmentsPortfolioUserComponent implements OnInit, OnChanges {
  @Input()
  public pagedCompanyAssignments: PageResult<CompanyPortfolioAssignmentDTO>;

  @Output()
  changePagination = new EventEmitter<FilterPagination>;

  @Output()
  markCompanyAsFavorite = new EventEmitter<SelectedCompanyAssignmentToMarkUnmarkFavorite>;

  @Output()
  unmarkCompanyAsFavorite = new EventEmitter<SelectedCompanyAssignmentToMarkUnmarkFavorite>;

  @ViewChild(MatPaginator, {static: false})
  public paginator: MatPaginator;
  public booleanFlag: boolean;
  public booleanText: boolean;
  public dataSource: MatTableDataSource<CompanyPortfolioAssignmentDTO>;
  public displayColumns = [
    'companyName',
    'companyRut',
    'sellAvgInvoices',
    'totalSellInvoices',
    'siiConnect',
    'favorite'
  ];

  constructor(){
    this.booleanFlag = true;
    this.booleanText = false;
   }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource([]);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['pagedCompanyAssignments']) {
      const pagedResult :PageResult<CompanyPortfolioAssignmentDTO> = changes['pagedCompanyAssignments'].currentValue;
      if(pagedResult) {
        this.setDataSource(pagedResult);
        this.booleanFlag = false;
      }
    }
    else { this.booleanFlag = false; this.booleanText = true; }
  }

  private setDataSource(pagedResult: PageResult<CompanyPortfolioAssignmentDTO>): void {
    this.dataSource.data = pagedResult.results ?? [];
    this.paginator.length = pagedResult?.totalRows ?? 0;
    if( pagedResult?.totalRows == 0) {
      this.booleanText = true;
    }
  }

  receiveChangePaginator(event: PageEvent): void {
    const pagination : FilterPagination = {
      page: event.pageIndex + 1,
      pageSize: event.pageSize
    };
    this.changePagination.emit(pagination);
  }

  clickToMarkOrUnmarkCompanyAssignmentAsFavorite(row: CompanyPortfolioAssignmentDTO) {
    const request: SelectedCompanyAssignmentToMarkUnmarkFavorite = {
      portfolioId: row.portfolioId,
      companyId: row.companyId
    };

    if(row.favorite) {
      this.unmarkCompanyAsFavorite.emit(request);
    } else{ 
      this.markCompanyAsFavorite.emit(request);
    }
  }

}
